// Rubber-band resistance for the card swipe — an asymptotic curve so small
// drags barely move and spring back, while a decisive swipe still travels. This
// is the "tasteful interaction tension" that keeps accidental grazes from
// flicking between documents. `max` caps the travel; `k` sets the stiffness
// (smaller = firmer). tension(0) === 0 and it's monotonic, so it composes
// cleanly with the rail's settle math.

export function tension(dx: number, max: number, k = 200): number {
  if (!dx) return 0;
  return Math.sign(dx) * max * (1 - Math.exp(-Math.abs(dx) / k));
}
